import React from 'react';
import { motion } from 'framer-motion';
export const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export const goToCheckout = () => {
  window.open('http://www.varenli.com/cart/42618988724318:1', '_blank');
};
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export const Button = ({
  children,
  variant = 'primary',
  className = '',
  onClick,
  ...props
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-dark',
    secondary: 'bg-white text-terracotta border-2 border-terracotta hover:bg-cream'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick || goToCheckout} {...props} data-id="element-229">
      {children}
    </button>;
};
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6,
  delay
}} className={className} data-id="element-230">
    {children}
  </motion.div>;